
<div class="flex flex-col items-start">
  <p
    ref="textBox"
    class="w-full text-body overflow-hidden"
    :class="[textBoxClasses]"
    :style="`word-break: break-word; -webkit-box-orient: vertical; display: ${
      expanded ? 'inline-block;' : '-webkit-box;'
    } -webkit-line-clamp: ${expanded ? 'none' : lineClamp};`"
  >
    <slot />
  </p>
  <button v-if="hasHiddenText" class="text-grey-clickable underline text-s mt-8" variant="text" @click="viewMoreHandler">
    {{ buttonText }}
  </button>
</div>
